"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const set_1 = require("../set");
const base_1 = require("./base");
/**
 * A pattern for ``<oneOrMore>``.
 */
class OneOrMore extends base_1.OneSubpattern {
    _computeHasEmptyPattern() {
        return this.pat.hasEmptyPattern();
    }
    newWalker() {
        const hasAttrs = this.hasAttrs();
        const currentIteration = this.pat.newWalker();
        // tslint:disable-next-line:no-use-before-declare
        return new OneOrMoreWalker(this, currentIteration, undefined, hasAttrs, this.pat, !hasAttrs || currentIteration.canEndAttribute, currentIteration.canEnd);
    }
}
exports.OneOrMore = OneOrMore;
/**
 * Walker for [[OneOrMore]]
 */
class OneOrMoreWalker {
    constructor(el, currentIteration, nextIteration, hasAttrs, subPat, canEndAttribute, canEnd) {
        this.el = el;
        this.currentIteration = currentIteration;
        this.nextIteration = nextIteration;
        this.hasAttrs = hasAttrs;
        this.subPat = subPat;
        this.canEndAttribute = canEndAttribute;
        this.canEnd = canEnd;
    }
    clone() {
        return new OneOrMoreWalker(this.el, this.currentIteration.clone(), this.nextIteration !== undefined ?
            this.nextIteration.clone() : undefined, this.hasAttrs, this.subPat, this.canEndAttribute, this.canEnd);
    }
    possible() {
        const ret = this.currentIteration.possible();
        if (this.currentIteration.canEnd) {
            if (this.nextIteration === undefined) {
                this.nextIteration = this.subPat.newWalker();
            }
            set_1.union(ret, this.nextIteration.possible());
        }
        return ret;
    }
    possibleAttributes() {
        const ret = this.currentIteration.possibleAttributes();
        if (this.currentIteration.canEnd) {
            if (this.nextIteration === undefined) {
                this.nextIteration = this.subPat.newWalker();
            }
            set_1.union(ret, this.nextIteration.possibleAttributes());
        }
        return ret;
    }
    fireEvent(name, params, nameResolver) {
        const evIsAttributeEvent = base_1.isAttributeEvent(name);
        if (evIsAttributeEvent && !this.hasAttrs) {
            return new base_1.InternalFireEventResult(false);
        }
        const currentIteration = this.currentIteration;
        const ret = currentIteration.fireEvent(name, params, nameResolver);
        if (ret.matched) {
            if (evIsAttributeEvent) {
                this.canEndAttribute = currentIteration.canEndAttribute;
            }
            this.canEnd = currentIteration.canEnd;
            return ret;
        }
        if (currentIteration.canEnd) {
            if (this.nextIteration === undefined) {
                this.nextIteration = this.subPat.newWalker();
            }
            const nextRet = this.nextIteration.fireEvent(name, params, nameResolver);
            if (nextRet.matched) {
                if (currentIteration.end()) {
                    throw new Error("internal error; canEnd returns true but end() fails");
                }
                this.currentIteration = this.nextIteration;
                this.nextIteration = undefined;
                if (evIsAttributeEvent) {
                    this.canEndAttribute = this.currentIteration.canEndAttribute;
                }
                this.canEnd = this.currentIteration.canEnd;
            }
            return nextRet;
        }
        return ret;
    }
    end() {
        return this.canEnd ? false : this.currentIteration.end();
    }
    endAttributes() {
        return this.canEndAttribute ? false : this.currentIteration.endAttributes();
    }
}
//  LocalWords:  RNG's MPL currentIteration nextIteration canEnd oneOrMore rng
//  LocalWords:  anyName suppressAttributes instantiateCurrentIteration
//# sourceMappingURL=one_or_more.js.map